import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import VenueContent from "./venue/Venue";
import AuthContext from "../contexts/AuthProvider";


import Loading from "../components/Loader";

import { API_URL } from "../utils/config";
const baseUrl = API_URL;

const Venue = () => {
  const [data, setData] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [addAttraction, setAddAttraction] = useState(false);
  const [editingAttraction, setEditingAttraction] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const id = useParams().venue_id || localStorage.getItem("venueId"); // Get the 'query' param
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };

  const fetchVenues = React.useCallback(async () => {
    if (!isAuthenticated) {
      setError(new Error("No authentication token found. Please log in."));
      setLoading(false);
      navigate("/");
      return;
    }
    try {
      const venueResponse = await fetch(`${baseUrl}/api/v1/attnd-venue/venues/${id}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),
        },
      });

      const reviewResponse = await fetch(
        `${baseUrl}/api/v1/attnd/review/venues/${id}/reviews`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
        }
      );

      if (!venueResponse.ok || !reviewResponse.ok) {
        if (venueResponse.status === 401) {
          navigate("/login");
          throw new Error("Unauthorized access. Please log in again.");
        } else if (venueResponse.status === 404) {
          alert("404 Not found.");
          navigate(-1);
          throw new Error("404 Not found.");
        } else {
          if (!venueResponse.ok)
            throw new Error(`An error occurred: ${venueResponse.statusText}`);
          else
            throw new Error(`An error occurred: ${reviewResponse.statusText}`);
        }
      }

      const venueData = await venueResponse.json();
      const reviewsData = await reviewResponse.json();
      setData(venueData);
      setReviews(reviewsData);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [id, isAuthenticated, navigate]);

  useEffect(() => {
    if (!addAttraction) fetchVenues();
  }, [addAttraction, fetchVenues]);

  if (loading) {
    return (
      <div className="loader-container">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="venue-venues-container">
        Error fetching venue: {error.message}
      </div>
    );
  }
  console.log(data);

  return (
    <VenueContent
      addAttraction={addAttraction}
      setAddAttraction={setAddAttraction}
      editingAttraction={editingAttraction}
      setEditingAttraction={setEditingAttraction}
      onVenueRefetch={fetchVenues}
      reviews={reviews}
      venue={data.venue_details}
    />
  );
};

export default Venue;
